import { render, staticRenderFns } from "./TabelaObrotow.html?vue&type=template&id=eef7cfda&scoped=true&external"
import script from "./TabelaObrotow.js?vue&type=script&lang=js&external"
export * from "./TabelaObrotow.js?vue&type=script&lang=js&external"
import style0 from "./TabelaObrotow.css?vue&type=style&index=0&id=eef7cfda&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef7cfda",
  null
  
)

export default component.exports